import API_URL from "../config";
import axios from "axios";
import { getCookie } from "./../utils/cookies";

export const createScanPermissionApi = async (scanData) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.post(`${API_URL}/api/V2/scans/create/${id}/${iv}`, scanData, option);
    return res.data;
  } catch (err) {
    console.error("Error in createScanPermissionApi:", err.response?.data || err.message);
    throw err;
  }
};

export const getAllScanPermissionsApi = async () => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(`${API_URL}/api/V2/scans/getAll/${id}/${iv}`, option);
    return res.data;
  } catch (err) {
    console.error("Error in getAllScanPermissionsApi:", err.response?.data || err.message);
    throw err;
  }
};

export const getOneScanPermissionApi = async (scanId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.get(`${API_URL}/api/V2/scans/${scanId}/${id}/${iv}`, option);
    return res.data;
  } catch (err) {
    console.error("Error in getOneScanPermissionApi:", err.response?.data || err.message);
    throw err;
  }
};

export const updateScanPermissionApi = async (scanId, scanData) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.put(`${API_URL}/api/V2/scans/${scanId}/${id}/${iv}`, scanData, option);
    return res.data;
  } catch (err) {
    console.error("Error in updateScanPermissionApi:", err.response?.data || err.message);
    throw err;
  }
};

export const deleteScanPermissionApi = async (scanId) => {
  try {
    const token = getCookie("T6hVzR7c0g3maM3F");
    const iv = getCookie("02hfCmUqpk66w4uG");
    const id = getCookie("3F2Mb2pJ1YRro5Z4");

    const option = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };

    const res = await axios.delete(`${API_URL}/api/V2/scans/${scanId}/${id}/${iv}`, option);
    return res.data;
  } catch (err) {
    console.error("Error in deleteScanPermissionApi:", err.response?.data || err.message);
    throw err;
  }
};
